<template>
  <b-modal
      :title=" `Bitácora`"
      v-model="showModal"
      @close="closeModal"
      hide-footer
      centered
  >
    <BinnacleList :binnacles="binnacle" />
  </b-modal>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import BinnacleList from '@/febos/chile/_vue/componentes/BinnacleList';

export default {
  props: {
    title: {
      type: String,
      required: false,
      default: null
    }
  },
  components: {
    BinnacleList
  },
  computed: {
    ...mapGetters('Billing', [
      'binnacle'
    ]),
    ...mapGetters('Modals', [
      'modalName'
    ]),
    showModal: {
      get() {
        return this.modalName === 'binnacle';
      },
      set() {
        this.closeModal();
      }
    }
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ])
  }
};

</script>
<style>
.wrap-binnacle {
  height: 400px;
  overflow-y: scroll;
}

.add-code {
  cursor: copy;
}

.crazy-zindex {
  z-index: 10001;
}
</style>
